import { getProductFactHashMapKey } from 'modules/desking/lib';
import { LayoutSections, ProductConfig } from '../types';
import { MenuConstructorState } from './types';

interface State {
  aftermarketMenuConstructor: MenuConstructorState;
}

const proposalsMenu = (state: State) => state.aftermarketMenuConstructor.proposalMenu;
const menuOptionToAddEdit = (state: State) => state.aftermarketMenuConstructor.menuOptionToAddEdit;
const selectedMenuOption = (state: State) => state.aftermarketMenuConstructor.selectedMenuOption;
const proposalsProducts = (state: State) => state.aftermarketMenuConstructor.proposalProducts.products;
const archivedMenuOptions = (state: State) => state.aftermarketMenuConstructor.archivedMenuOptions;
const initialProposalMenu = (state: State) => state.aftermarketMenuConstructor.initialProposalMenu;
const selectedProposalsProducts = (state: State) => state.aftermarketMenuConstructor.selectedProposalsProducts;
const selectedProposalsProductsIds = (state: State) =>
  state.aftermarketMenuConstructor.selectedProposalsProducts.map(p => p.proposalProductId);
const partnerLinksById = (state: State) => state.aftermarketMenuConstructor.partnerLinksById;
const isLoading = (state: State) => state.aftermarketMenuConstructor.isLoading;
const proposalProductConfigurations = (state: State) =>
  state.aftermarketMenuConstructor.proposalProducts.productsConfiguration;
const proposalProductConfigurationsInMenu = (state: State) =>
  state.aftermarketMenuConstructor.proposalProducts.productsConfigurationInMenu;
const proposalProductConfigurationById = (state: State, productId: string) =>
  state.aftermarketMenuConstructor.proposalProducts.productsConfiguration[productId];

const selectedProductsFactsForCheck = (state: State) =>
  state.aftermarketMenuConstructor.proposalProducts.productsFactsToCheck;

const selectedProductsFactsSkipped = (state: State) =>
  state.aftermarketMenuConstructor.proposalProducts.productFactsSkipped;

const selectedProductsFactsForCheckArray = (state: State) =>
  Object.entries(selectedProductsFactsForCheck(state))
    .filter(([id]) => selectedProposalsProducts(state).map(getProductFactHashMapKey).includes(id))
    .map(([_, facts]) => facts)
    .flat();

const isSectionCollapsed = (state: State, section: LayoutSections) =>
  state.aftermarketMenuConstructor.layout.sections?.[section]?.isCollapsed ?? true;

const selectedProductsConfigurations = (state: State) => {
  const selectedProductsIds = selectedProposalsProductsIds(state);

  return selectedProductsIds.reduce<Record<string, ProductConfig>>((acc, productId) => {
    acc[productId] = proposalProductConfigurationById(state, productId);
    return acc;
  }, {});
};

export const menuConstructorSelectors = {
  isLoading,
  proposalsMenu,
  proposalsProducts,
  menuOptionToAddEdit,
  selectedMenuOption,
  archivedMenuOptions,
  initialProposalMenu,
  selectedProposalsProducts,
  selectedProductsFactsForCheck,
  selectedProductsFactsSkipped,
  selectedProductsFactsForCheckArray,
  selectedProductsConfigurations,
  partnerLinksById,
  proposalProductConfigurations,
  proposalProductConfigurationById,
  proposalProductConfigurationsInMenu,
  isSectionCollapsed,
};
